import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useSetPasswordValidateMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useSetPasswordValidate = () => {
  const [handle, { data, loading, error: apolloError }] =
    useSetPasswordValidateMutation();

  const error = useError(apolloError);

  return {
    data,
    loading,
    error,
    setPasswordValidate: useCallback(
      async (newPassword: string) => {
        const res = await handle({
          variables: { newPassword },
        });
        return res.data?.passwordValidate;
      },
      [handle]
    ),
  };
};
